/**
 * @generated SignedSource<<71975c2f00a1f819a29cdcec82abd300>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type isRateUnavailable_rate$data = {
  readonly alreadyAdded: boolean;
  readonly room: {
    readonly capacity: number | null;
  } | null;
  readonly " $fragmentType": "isRateUnavailable_rate";
};
export type isRateUnavailable_rate$key = {
  readonly " $data"?: isRateUnavailable_rate$data;
  readonly " $fragmentSpreads": FragmentRefs<"isRateUnavailable_rate">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "isRateUnavailable_rate"
};

(node as any).hash = "5effc6b7ed8b6f5caed5ee8747eab2da";

export default node;
